/** @file 话题PK 语言配置 */
const zhCN = {
  topic: {
    joinCounts: '人参与',
    going: '进行中',
    end: '已结束',
    nobody: '0 人投票',
    deleteTopic: '该话题被删除'
  },
};

const en = {
  topic: {
    joinCounts: 'participants',
    going: 'In progress',
    end: 'End',
    nobody: '0 participants',
    deleteTopic: 'Topic deleted'
  },
};

export default {
  zh_CN: zhCN,
  en,
};
